import * as React from "react";

import classNames from "classnames";
import './ValidationMessage.scss';

export interface IValidationMessageProps {
    className?: string;
    alertType?: string;
}

class ValidationMessage extends React.Component<IValidationMessageProps, any> {
    render() {

        const {
            children,
            className,
            alertType
        } = this.props;

        const derivedAlertType = alertType ? alertType : 'alert-danger';
            

        return <div>
            <div className={classNames
                (
                "alert",
                derivedAlertType,
                "validation-message",
                className
                )} role="alert">
                {
                    children
                }
            </div>
        </div>
    }
}

export default ValidationMessage;
